<template>
  <el-form :model="formData" label-width="130px">
    <el-row>
      <el-col :span="24">
        <el-form-item style="font-weight: bold" label="设置隐藏楼面单元:"/>
      </el-col>
      <el-col :span="20">
        <el-cascader style="width: 100%;" :options="floorUnitNoList" :props="props" :filter-method="filterMethod" @visible-change="handleVisibleChange" v-model="hide_unit_nos" :show-all-levels="false" placeholder="请选择" clearable filterable />
      </el-col>

      <el-col :span="4" style="margin-top: auto;padding-left: 5px;">
        <el-button style="padding: 0 8px;" type="success" :loading="loading1" @click="clickDataAll">一键全选</el-button>
        <el-button style="padding: 0 8px;" type="danger" :loading="loading1" @click="clickDataClean">一键清除</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" style="text-align: center;margin-top: 15px;">
        <el-button type="primary" :loading="loading" @click="saveWujianInfo" style="width: 100px;">编辑</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "MfgWuJianInfoEdit2",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      formData: this.parentData,
      hide_unit_nos:[],
      queryUnitNoList: [],
      floorUnitNoList: [],
      loading: false,
      props:{ multiple: true },
      loading1:false
    }
  }
  , methods: {
    saveWujianInfo() {
      //console.log("this.formData==",this.formData)
      this.formData.wuJianInfoEdit = 2; //区分 第一个还是第二个页面
      this.formData.hide_unit_nos = this.hide_unit_nos.map(path => path.toString().includes(",")?path[path.length - 1]:path);
      this.$axios.post('mfg/wuJianInfo/saveWujianInfo', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        this.$message.success("编辑成功");
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //一键全选
    clickDataAll() {
      this.loading1 = true;
      let hide_unit_nos = [];
      for (let item of this.hide_unit_nos) {
        if (item.toString().includes(",")) {
          let proxyArr = new Proxy(item, {
            get: function (target, prop) {
              return target[prop];
            }
          });
          hide_unit_nos.push(proxyArr)
        } else {
          hide_unit_nos.push(item)
        }
      }

      const myMap = new Map();
      for (let item of hide_unit_nos) {
        let a = item.toString().includes(",")?item[item.length - 1]:item;
        myMap.set(a,a);
      }

      for (let item of this.queryUnitNoList) {
        let a = item.toString().includes(",")?item[item.length - 1]:item;
        if (!myMap.has(a)) {
          hide_unit_nos.push(item)
        }
      }

      this.hide_unit_nos = hide_unit_nos;
      this.loading1 = false;
    },
    //一键清除
    clickDataClean() {
      this.loading1 = true;
      const myMap = new Map();
      for (let item of this.queryUnitNoList) {
        let a = item.toString().includes(",")?item[item.length - 1]:item;
        myMap.set(a,a);
      }
      let hide_unit_nos = [];
      for (let item of this.hide_unit_nos) {
        let a = item.toString().includes(",")?item[item.length - 1]:item;
        if (!myMap.has(a)) {
          hide_unit_nos.push(item)
        }
      }

      this.hide_unit_nos = hide_unit_nos;
      this.loading1 = false;
    },
    handleVisibleChange(visible) {
      if (visible) {
        this.queryUnitNoList = [];
      }
    },
    filterMethod(node,query) {
      let nodeData = node.data;
      if (nodeData.value.includes(query)) {
        let proxyArr = new Proxy(node.pathValues, {
          get: function(target, prop) {
            return target[prop];
          }
        });
        this.queryUnitNoList.push(proxyArr)
      }

      return node.data.value.includes(query);
    },
    getFloorUnitNoList() {
      this.$axios.post('mfg/wuJianInfo/getFloorUnitNoList', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.floorUnitNoList = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getHideUnitNos() {
      this.$axios.post('mfg/wuJianInfo/getHideUnitNos', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.hide_unit_nos = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  }, created() {
    this.getHideUnitNos();
    this.getFloorUnitNoList();
  }
}
</script>

<style scoped>

</style>